import React, { useState } from "react";
import { List, ListItem, Collapse } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import NavItem from "../../lib/bandung/components/helpers/NavItem";

export default function SearchPageFiltersDropdown({ labelText, subItems }) {

    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(!open);
    };
    return (
        <>
            {/* <li><input type="checkbox" name="" id="" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/><span className="text-lg"> Filter 1</span></li> */}
            
            <ListItem onClick={handleClick} style={{paddingBottom : '0px'}} >
                {labelText}
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div">
                    {subItems.map((subItem, index) => (

                        <NavItem
                            key={index}
                            labelText={subItem.labelText}
                            to={subItem.to}
                        />
                    ))}
                </List>
            </Collapse>
        </>
    );
}